const FirebaseConfig = {
  apiKey: "AIzaSyCV3HEnxWeb5NLppwYy6DVLtTR43sLWKLA",
  authDomain: "blood-hstu.firebaseapp.com",
  projectId: "blood-hstu",
  storageBucket: "blood-hstu.appspot.com",
  messagingSenderId: "367054572787",
  appId: "1:367054572787:web:7fbe4f1ce9d6554469fb86"
};
  
  export default FirebaseConfig;